import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-diffusion-paquets-dialog',
    templateUrl: './diffusion-paquets-dialog.component.html',
    imports: [
    MatDialogModule,
    TranslateModule
]
})
export class DiffusionPaquetsDialogComponent {
  currentLang: string = 'fr';

  constructor(
    private dialogRef: MatDialogRef<DiffusionPaquetsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      titre: string;
      scormPackageNomLocales: { [lang: string]: string }[];
    },
    private translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || 'fr';
  }

  getNomPackage(locales: { [lang: string]: string }): string {
    return locales[this.currentLang] || locales['fr'] || '';
  }

  onFermer(): void {
    this.dialogRef.close();
  }
}
